import SalonMenuGrid from "./SalonMenuGrid";
import SalonMenuGridItem from "./SalonMenuGridItem";

const exportObjs = {
  Grid: SalonMenuGrid,
  GridItem: SalonMenuGridItem,
};

export default exportObjs;
